/**
 * Exhaustive list of banks Amplify has transacted with creators across campaigns,
 * keyed by ISO 3166-1 alpha-2 country code.
 */
export const BANKS_BY_COUNTRY: Record<string, readonly string[]> = {
	AR: ["Banco de Galicia y Buenos Aires"],
	AU: ["Commonwealth Bank", "Westpac Banking Corporation"],
	BE: ["KBC Bank NV", "Wise (payment rails / beneficiary)"],
	BR: ["Banco Bonsucesso S.A.", "Banco BS2 S.A. (Cayman USD account)"],
	CA: ["Royal Bank of Canada"],
	EG: ["Commercial International Bank (CIB)", "Credit Agricole Egypt", "Bank of Alexandria"],
	FJ: [
		"BSP Financial Group Limited",
		"Australia and New Zealand Banking Group Limited (ANZ)",
		"Westpac Banking Corporation",
		"Column National Association (USD payout)",
	],
	PF: ["Community Federal Savings Bank (USD payout)"],
	FR: ["OLINDA SAS (Qonto)", "BNP Paribas", "Crédit Mutuel", "Revolut Payments UAB", "Boursorama", "Deblock SAS"],
	DE: [
		"N26 Bank AG",
		"Commerzbank AG",
		"Sparkasse KölnBonn",
		"Sparkasse Darmstadt und Dieburg",
		"Sparkasse Attendorn Lennestadt Kirchhundem",
		"Landessparkasse zu Oldenburg",
		"Deutsche Kreditbank AG (DKB)",
		"Volks- und Raiffeisenbank Saale-Unstrut",
	],
	HK: ["The Hongkong and Shanghai Banking Corporation Limited (HSBC)"],
	HU: ["K&H Bank Zrt."],
	ID: ["PT Bank Central Asia Tbk (BCA)", "PT Bank Negara Indonesia (Persero) Tbk (BNI)"],
	IT: [
		"UniCredit S.p.A.",
		"Intesa Sanpaolo S.p.A.",
		"Banca Sella S.p.A.",
		"Banca di Piacenza",
		"Banca Popolare Pugliese",
		"Fin-Eco Banca ICQ S.p.A. (Banca Fin-Eco S.p.A.)",
	],
	JP: ["MUFG Bank, Ltd."],
	KE: ["Absa Bank Kenya PLC"],
	MY: ["Maybank Berhad / Malayan Banking Berhad", "Public Bank Berhad", "CIMB Bank Berhad"],
	MV: ["Bank of Maldives PLC", "Maldives Islamic Bank PLC"],
	MN: ["Golomt Bank"],
	MA: [
		"Attijariwafa Bank (AWB)",
		"Bank of Africa (BMCE)",
		"Banque Centrale Populaire (BCP)",
		"Banque Populaire Rabat Kénitra",
		"CIH Bank",
	],
	NL: ["ING Bank N.V."],
	NG: ["Zenith Bank Plc", "Providus Bank", "Column National Association (USD payout)"],
	PH: [
		"Union Bank of the Philippines",
		"Security Bank",
		"Banco de Oro Universal Bank (BDO)",
		"Bank of the Philippine Islands (BPI)",
		"Maya Bank, Inc.",
	],
	PL: ["ING Bank Śląski"],
	RO: ["Revolut Bank UAB (Bucharest)"],
	SA: ["The Saudi National Bank"],
	SG: ["Oversea-Chinese Banking Corporation Limited (OCBC)"],
	ZA: ["FirstRand Bank / First National Bank (FNB) / Rand Merchant Bank (RMB)", "Standard Bank"],
	KR: ["Woori Bank"],
	ES: ["Banco Bilbao Vizcaya Argentaria (BBVA)", "CaixaBank, S.A.", "Banco de Sabadell, S.A."],
	TW: ["Cathay United Bank", "CTBC Bank"],
	TH: [
		"Bank of Ayudhya Public Company Limited (Krungsri)",
		"Siam Commercial Bank",
		"Kasikornbank Public Company Limited",
		"TMBThanachart Bank Public Company Limited",
	],
	AE: ["Emirates NBD Bank"],
	GB: ["Barclays Bank UK PLC", "Monzo Bank Ltd", "Coutts", "ClearBank Limited"],
	US: [
		"JPMorgan Chase Bank, N.A. / Chase Bank",
		"Wells Fargo Bank, N.A.",
		"PNC Bank, National Association",
		"Choice Financial Group",
		"Community Federal Savings Bank",
	],
	VN: [
		"Joint Stock Commercial Bank for Foreign Trade of Vietnam (Vietcombank)",
		"Vietnam Technological and Commercial Joint Stock Bank (Techcombank)",
		"Military Commercial Joint Stock Bank (MB Bank)",
	],
};

/** Flat unique list — fallback when country has no curated banks. */
export const ALL_BANK_NAMES: readonly string[] = Array.from(new Set(Object.values(BANKS_BY_COUNTRY).flat())).sort(
	(a, b) => a.localeCompare(b),
);

export function getBanksForCountry(countryCode?: string | null): readonly string[] {
	const code = (countryCode ?? "").trim().toUpperCase();
	if (code && BANKS_BY_COUNTRY[code]) {
		return BANKS_BY_COUNTRY[code];
	}
	return ALL_BANK_NAMES;
}
